Date.prototype.getWeek = function getWeek() {
  const target = new Date(this.valueOf());
  const dayNr = (this.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  const firstThursday = target.valueOf();
  target.setMonth(0, 1);
  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
  }
  return 1 + Math.ceil((firstThursday - target) / 604800000);
};

export function getWeekRange(weekNumber, year = null) {
  const resolvedYear = year ?? new Date().getFullYear();
  const firstMonday = new Date(resolvedYear, 0, 4);
  firstMonday.setDate(
    firstMonday.getDate() - ((firstMonday.getDay() + 6) % 7) + (weekNumber - 1) * 7,
  );

  const weekStart = new Date(firstMonday);
  const weekEnd = new Date(firstMonday);
  weekEnd.setDate(weekEnd.getDate() + 6);

  const formatVN = (date) => date.toLocaleDateString("vi-VN");

  return {
    start_date: formatVN(weekStart),
    end_date: formatVN(weekEnd),
  };
}

export function timeToHuman(updatedAt) {
  const parts = new Date(updatedAt).toString().split(/\s/);
  const monthMap = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };
  return `${parts[2]}/${monthMap[parts[1]]}/${parts[3]} ${parts[4]}`;
}
